export default __webpack_public_path__ + "static/media/warning-success.072b9561.svg";